module.exports = __webpack_public_path__ + "static/media/prosapient.db320f64.png";